import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class PlanningDashboardBalanceIndexRoute extends Route {
  @service router;
  beforeModel() {
    this.modelFor('planning.dashboard.balance')?.reload();
    return this.router.transitionTo('planning.dashboard.balance.view');
  }
}

export default instrumentRoutePerformance(PlanningDashboardBalanceIndexRoute);
